export default __webpack_public_path__ + "static/media/16.2b673755.jpeg";